import { useCallback } from "react"

import {
  useTransportMutation,
  useTransportQuery,
  useTransportQueryUtils,
} from "@/transport"

export function useMetricCatalogEntriesTransport() {
  return useTransportQuery({ operation: "listMetricCatalogEntries" })
}

export function useCopyMetricCatalogEntryTransport() {
  const transportQueryUtils = useTransportQueryUtils()
  const mutation = useTransportMutation("copyMetricCatalogEntry")

  const copyMetricCatalogEntry = useCallback(
    async (entryId: string) => {
      try {
        const response = await mutation.mutateAsync({ entry_id: entryId })
        return response.metric
      } finally {
        await Promise.allSettled([
          transportQueryUtils.invalidateOperation("listMetrics"),
        ])
      }
    },
    [mutation, transportQueryUtils],
  )

  return {
    copyMetricCatalogEntry,
    isCopying: mutation.isPending,
  }
}
